export default __webpack_public_path__ + "static/media/children_services.a7b0eada.jpg";